import React from "react";

export default function Badge({ children, type = 'default', icon, color, width = '100%', align = 'center' }) {
    const getBackgroundColor = () => {
        switch (type) {
            case 'primary':
                return '#1976d2';
            case 'secondary':
                return '#9c27b0';
            case 'success':
                return '#2e7d32';
            case 'error':
                return '#d32f2f';
            case 'warning':
                return '#ed6c02';
            case 'info':
                return '#0288d1';
            case 'none':
                return 'transparent';
            default:
                return '#e0e0e0';
        }
    };

    const backgroundColor = color || getBackgroundColor();

    return (
        <span
            style={{
                backgroundColor,
                color: ['default', 'none'].includes(type) ? '#000' : '#fff',
                borderRadius: '8px',
                padding: '1px 6px',
                fontSize: '12px',
                display: 'inline-flex',
                alignItems: 'center',
                gap: icon ? '4px' : '0',
                width:width,
            }}
        >
            {icon && <span style={{ display: 'flex', alignItems: 'center' }}>{icon}</span>}
            <span style={{ textAlign: align, width: '100%' }}>
            {children}
            </span>
        </span>
    );
}
